import { npubEncode } from "nostr-tools/nip19";
import { ellipsize, parseJson } from "@welshman/lib";
import { getLnUrl } from "./Zaps.js";
import { PROFILE } from "./Kinds.js";
export const isPublishedProfile = (profile) => Boolean(profile.event);
export const makeProfile = (profile = {}) => {
    if (typeof profile.lud06 === "string") {
        const lnurl = getLnUrl(profile.lud06);
        if (lnurl) {
            profile = { ...profile, lnurl };
        }
    }
    if (typeof profile.lud16 === "string") {
        const lnurl = getLnUrl(profile.lud16);
        if (lnurl) {
            profile = { ...profile, lnurl };
        }
    }
    return profile;
};
export const readProfile = (event) => ({
    ...makeProfile(parseJson(event.content) || {}),
    event,
});
export const createProfile = ({ event, ...profile }) => ({
    kind: PROFILE,
    content: JSON.stringify(profile),
});
export const editProfile = ({ event, ...profile }) => ({
    kind: PROFILE,
    content: JSON.stringify(profile),
    tags: event.tags,
});
export const displayPubkey = (pubkey) => {
    const d = npubEncode(pubkey);
    return d.slice(0, 8) + "…" + d.slice(-5);
};
export const displayProfile = (profile, fallback = "") => {
    const { display_name, name, event } = profile || {};
    if (name)
        return ellipsize(name, 60).trim();
    if (display_name)
        return ellipsize(display_name, 60).trim();
    if (event)
        return displayPubkey(event.pubkey).trim();
    return fallback.trim();
};
export const profileHasName = (profile) => Boolean(profile?.name || profile?.display_name);
//# sourceMappingURL=Profile.js.map